import React, { useEffect } from "react";
import ProfileForm from "./ProfileForm";
import { Profile } from "./ProfileForm";
import { buildApiUrl } from "../utils/apiConfig";
import "../styles/edit-team-member-modal.css";

type Props = {
    open: boolean;
    onClose: () => void;
    onSaved?: (saved: Profile) => void;
    userId: string;
    loadUrl?: string;
    saveUrl?: string;
    useCookies?: boolean;
};

export default function EditTeamMemberModal({
    open,
    onClose,
    onSaved,
    userId,
    loadUrl,
    saveUrl,
    useCookies = true
}: Props) {
    // Set flag to indicate editing another user's profile (not own profile)
    useEffect(() => {
        if (open) {
            localStorage.setItem('loggedInUserEdit', 'false');
        }
        return () => {
            // Clean up flag when modal closes
            localStorage.removeItem('loggedInUserEdit');
        };
    }, [open]);

    // Close modal on Escape key
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => (open && e.key === "Escape" ? onClose() : undefined);
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    const defaultLoadUrl = buildApiUrl(`api/admins/${encodeURIComponent(userId)}/profile`);
    const defaultSaveUrl = buildApiUrl(`api/admins/${encodeURIComponent(userId)}/profile`);

    const handleSaved = (saved: Profile) => {
        onSaved?.(saved);
        onClose();
    };

    return (
        <div className="edit-member-modal" role="dialog" aria-modal="true" aria-labelledby="edit-member-modal-title">
            <div className="edit-member-modal-card">
                <button className="edit-member-modal-close" aria-label="Close" onClick={onClose}>×</button>
                <div className="edit-member-modal-content">
                    <ProfileForm
                        loadUrl={loadUrl || defaultLoadUrl}
                        saveUrl={saveUrl || defaultSaveUrl}
                        useCookies={useCookies}
                        onSaved={handleSaved}
                        onClose={onClose}
                        userId={userId}
                        isTeamMemberEdit={true}
                    />
                </div>
            </div>
        </div>
    );
}
